import React from 'react'
import { Link } from 'gatsby'
import { Flex, Button, Heading, Text } from 'theme-ui'
import { FaRegHandshake } from 'react-icons/fa'

const styles = {
  wrapper: {
    alignItems: `center`,
    flexDirection: `column`,
    bg: `omegaLighter`,
    borderRadius: `lg`,
    size: `full`,
    p: 4,
  },
  heading: {
    color: `omegaDark`,
    wordSpacing: 500, //force line breaks
    svg: {
      color: `beta`,
      size: `icon.lg`,
      display: `block`,
      mb: 3,
    },
  },
  subheading: {
    color: `omegaDark`,
    fontWeight: `normal`,
  },
  list: {
    color: `omegaDark`,
    listStyle: `none`,
    m: 0,
    p: 0,
    li: {
      p: 0,
      my: 2,
    },
    'li:before': {
      content: `""`,
      display: `inline-block`,
      width: `icon.xs`,
      bg: `success`,
      borderRadius: `full`,
      size: `7px`,
      mr: `7px`,
    },
  },
  button: {
    display: `block`,
    mt: `auto`,
  },
}

const BannerVertical = () => (
  <Flex sx={styles.wrapper}>
    <Heading variant='h2' sx={styles.heading}>
      <FaRegHandshake />
      できればコード<br></br>書きたくない
    </Heading>
    <Heading variant='h4' sx={styles.subheading}>
      そんな怠惰なあなたにピッタリのブログ、それが「ZenApp」です。<br></br>NoCodeサービスの紹介や、DX関連の業務自動化ソースコードを一般公開しています。
    </Heading>
    <Text as='ul' variant='small' sx={styles.list}>
      <li>楽してお金を儲けたい</li>
      <li>最低限の努力で最高の成果</li>
      <li>リスクマネジメントも</li>
    </Text>
    <Heading variant='h4' sx={styles.subheading}>
      現在当ブログの管理人は、実労働１時間で月商４５万円ほど稼いでいます。
    </Heading>
    <Button
      variant='primary'
      as={Link}
      to='/'
      sx={styles.button}
      aria-label='Learn More'
    >
      管理人プロフィール
    </Button>
  </Flex>
)

export default BannerVertical
